import { ZendeskApi, ZendeskSettings } from './types';

export function hasZendeskSettingsConfigured(window: Window): window is Window & { zESettings: ZendeskSettings } {
  return typeof window.zESettings !== 'undefined';
}

export function hasZendeskApiInitialized(window: Window): window is Window & { zE: ZendeskApi } {
  return typeof window.zE === 'function';
}
